// Func = limiting Scope for this file
var lastScrollTop = 0;
//datepicker booking
var opened = 0;
var start = $("#arriveInput").attr("value");
var end = $("#departureInput").attr("value");
var opencheck = 0;
var firstClick = 0;

(function () {
  if (!window.ActiveXObject && "ActiveXObject" in window) {
    //is explorer
    function msieversion() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        const image_fit = document.getElementsByClassName("image-fit__wrapper");
        for (let i = 0; i < image_fit.length; i++) {
          const this_image = image_fit[i].getElementsByTagName("img")[0];
          const image_data = this_image.dataset.srcset;
          const image_src = this_image.getAttribute("src");
          image_fit[i].classList.add("ie-bg");
          if (image_data) {
            image_fit[i].style.backgroundImage = 'url("' + image_data + '")'; 
          } else {
            image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
          }
        }
      } else {
        console.log("other browser");
      }

      return false;
    }

    msieversion();
  } else {
    /*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
    var scrollParallax = [];
    var scrolled = 0;

    // screen height
    var v_height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    function doParallax(elm) {
      let boundes = elm.dataset.parallax.split(","); // get it from html
      //get distance in positive value
      let distance = Math.abs(boundes[0] - boundes[1]);
      if (boundes[0] > boundes[1]) {
        //get distance in negative value (to do the scroll inverse)
        distance = distance * -1;
      }
      //Equivalent distance using screen height + element height
      const unit_scroll = distance / (v_height + elm.offsetHeight);
      let temp = 0;

      let topElement = 0;
      let element = elm;

      let id_elem = elm.dataset.parallaxid;

      do {
        topElement += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);

      let parallaxFunction = function () {
        //Obtain the distance between top screen and document top 0
        scrolled = document.documentElement.scrollTop || window.pageYOffset;
        //Distance of bottom page to top of the element
        let relative_distance = scrolled + v_height - topElement;
        //transpoling data to move the parallax element relative to the scroll of all the screen
        temp = unit_scroll * relative_distance + parseInt(boundes[0]);
        //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
        elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
      };

      scrollParallax[id_elem] = parallaxFunction;

      window.addEventListener("scroll", scrollParallax[id_elem]);
    }

    let observers_parallax = document.querySelectorAll(".js-parallax-element");

    if (observers_parallax) {
      let options_parallax = {
        root: null, // relative to document viewport
        rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0, // visible amount of item shown in relation to root
      };

      function handler_parallax(entries, observer) {
        let entry;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            doParallax(entry.target);
          } else {
            let id_elem = entry.target.dataset.parallaxid;
            window.removeEventListener("scroll", scrollParallax[id_elem]);
          }
        });
      }

      let observable_parallax = new IntersectionObserver(
        handler_parallax,
        options_parallax
      );
      let counter = 1;
      observers_parallax.forEach(function (element) {
        observable_parallax.observe(element);
        element.dataset.parallaxid = counter;
        counter++;
      });
    }
    /********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
  }


  // Menu Images Function
	let primaryNavigation = document.querySelectorAll('#privary-navigation > li');
	let menuGallery = document.querySelectorAll('.menu-block__images img');
	primaryNavigation.forEach((li, i)=>{
		li.addEventListener( "mouseenter", () => {
      if( !li.parentElement.classList.contains('submenu') ){
        console.log(i);
        console.log(li);
        let liIndex = i;
        menuGallery.forEach((img)=>{
          img.classList.remove('active');
        });
        menuGallery[liIndex].classList.add('active');
      }
		});
	});

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
        itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
      itemMenu.querySelector('.submenu').style.display = 'none';
		}
	})

	// Menu Functionality

	let menuContent = document.getElementById("navigationBox");
	//Open/CLose
	if(menuContent){
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-toggle_nav]");	
		let menuLabel = menuBtn.querySelector('div.text');
		let body = document.querySelector('body');
		menuBtn.addEventListener('click', function (e) {
			console.log('condiciones');
			
			menuBtn.classList.toggle("open");
			menuContent.classList.toggle("open");
			header.classList.toggle("menuOpen");
			body.classList.toggle("no-overflow");
			if(document.querySelector('#navMenuBar')){
				document.querySelector('#navMenuBar').classList.toggle("open");
			}
			if (menuLabel.innerHTML == "Menu") {
				menuLabel.innerHTML = "Close";
			} else {
				menuLabel.innerHTML = "Menu";
			}
		});

	}


  $(".form-module-wrapper form").addClass("animate-fade top");
  $(".text-modules-wrapper .text-modules").addClass("animate-fade top");

  //header click reserve
  let BookingBox = document.getElementById("bookingBox");
  let BtnReserve = document.getElementById("js_btn_book");
  let BtnClose = document.getElementById("btn-close");

  BtnReserve.addEventListener("click", function (e) {
    e.preventDefault();
    BookingBox.classList.add("open");
    document.body.classList.add("scroll-no");
  });
  BtnClose.addEventListener("click", function (e) {
    e.preventDefault();
    BookingBox.classList.remove("open");
    document.body.classList.remove("scroll-no");
  });

  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    let title = document.querySelector("#accordion > h3");
    let paragraph = document.querySelector("#accordion > p");

    if(title){
      title.addEventListener("click", function () {
        console.log("click");
        paragraph.classList.toggle("active");
      });
    }

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  });

    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    // scrollDownAction(20, 'scroll');
    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });

  // function scrollToElement(id) {
	// 	const el = document.querySelector(id);
	// 	if (el) {
	// 		el.scrollIntoView();
	// 	}
	// }

	// window.addEventListener('DOMContentLoaded', (event) => {
	// 	const { href } = window.location;
	// 	if (href.lastIndexOf('#')) {
	// 		const id = href.substring(href.lastIndexOf('#'), href.length);
	// 		scrollToElement(id);
	// 	}
	// });

  function scrollToElement(id, target = "" ) {

    console.log({id, target});

    const el = document.getElementById(id)

    if (el && target) {

      el.scrollIntoView();
      if ( target == "meetings") {
        document.querySelector(`a[data-tag="Meetings"]`).click();
      }

    } else if( el ) {
      console.log({ el });
      el.scrollIntoView();
    }
  }
  
  window.addEventListener('DOMContentLoaded', (event) => {
    const { href } = window.location;
  
    if (href.indexOf('#') > -1 && href.indexOf('?') > -1 ) {
      const hashPart = href.substring(href.indexOf('#'),  href.indexOf('?')).split('#')[1];

      // console.log({ hashPart }, "FIRST");

      if (href.indexOf('target=') > -1) {
        const targetParam = new URLSearchParams(href.substring(href.indexOf('?'))).get('target');

        if (targetParam) {
          console.log(`Parameter target': ${targetParam}`);
          scrollToElement(hashPart, targetParam);
        }


      }
    } else if( href.indexOf('#') > -1){
      const hashPart = href.substring(href.indexOf('#'));
      console.log({ hashPart });
      scrollToElement(hashPart);

    } else {

      return;
    }
  });
  

})();

function scrollW() {

  if(document.querySelector( "#readblog" )){
    document.querySelector( "#readblog" ).classList.add( "scrolling" );
    setTimeout( () => { document.querySelector( "#readblog" ).classList.remove( "scrolling" ); }, 1000 )
  }

  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}